import { Handle, Position } from "reactflow";
import { Button } from "@components/Input";

import { useFlowNodes } from "../../../../../context";
import { nodesExist } from "../../../../utils/hasNodes";
import { addNodeExtension } from "../../../../utils/addNode";

import "./ButtonAddExtensions.scss";
import { addVariable } from "../../../../utils/addVariables";
import { typesNodes } from "../../../../../types/nodeTypes/typesNodes";

export const ButtonAddExtensions = (dataNode, id) => {
  const {
    t,
    intent,
    variables,
    updateIntent,
    updateVariables,
    nodes,
    setNodes,
    setEdges,
  } = useFlowNodes();
  return (
    <>
      <Handle type="target" position={Position.Left} />
      <Handle type="source" id={id} position={Position.Right} />
      <div>
        <Button
          className="btn_add_node"
          onClick={(e) => {
            addVariable({
              variables,
              updateVariables,
              updateIntent,
              intent,
            });
            addNodeExtension({
              nodesExist: nodesExist({
                nodes,
                parentId: dataNode.data.parentData.id,
              }),
              setNodes,
              setEdges,
              dataNode: dataNode,
              type: typesNodes.extensionsVariablesFlow,
              dataInfo: {
                indexParam: variables.length - 1,
              },
              offsetX: 434,
              offsetY: 69,
            });
          }}
          text={t(
            "intents.config.accordion.extensions.content.variables.button"
          )}
        />
      </div>
    </>
  );
};
